import { makeStyles } from "@material-ui/styles";
import {
  CheckCircledIcon,
  CrossCircledIcon,
  DownloadIcon,
  FileTextIcon
} from "@radix-ui/react-icons";
import { Box, Button, Flex, Text } from "@radix-ui/themes";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    height: "100%",
    width: "100%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 3000,
    backgroundColor: "rgba(1,1,1,0.5)"
  },
  panel: {
    backgroundColor: "var(--neutral-1)",
    border: `1px solid var(--neutral-a6)`,
    borderRadius: "16px"
  },
  icon: {
    color: "var(--accent-11)"
  },
  button: {
    backgroundColor: "var(--accent-11)",
    width: "114px",
    height: "32px",
    "&:hover": {
      cursor: "pointer"
    }
  },
  clickableText: {
    color: "var(--accent-11)",
    "&:hover": {
      cursor: "pointer"
    }
  },
  hover: {
    "&:hover": {
      cursor: "pointer"
    }
  }
}));
export default function BijPdfModal(props) {
  const {
    filename,
    cancelGenerate,
    regenerate,
    downloadOverride,
    downloadOverrideUrl
  } = props;
  const classes = useStyles();
  const downloadPdf = () => {
    if (downloadOverride && downloadOverrideUrl) {
      props.downloadPdf(downloadOverrideUrl);
    } else {
      props.downloadPdf();
    }
  };
  return (
    <div className={`${classes.root} removeForExport`}>
      <Flex
        width="350px"
        height="304px"
        className={classes.panel}
        p="4"
        direction={"column"}
      >
        <Flex justify="end" width="100%">
          <CrossCircledIcon
            className={classes.hover}
            onClick={cancelGenerate}
          />
        </Flex>
        <Flex direction="column" gap="8px">
          <Flex justify={"center"}>
            <Box className={classes.icon}>
              <CheckCircledIcon width="28.26px" height="28.26px" />
            </Box>
          </Flex>
          <Flex justify={"center"}>
            <Text size="5" weight="bold">
              Your document is ready.
            </Text>
          </Flex>
          <Flex gap="8px" justify="center">
            <FileTextIcon />
            <Text size="1" weight="regular">
              PDF Format
            </Text>
          </Flex>
          <Flex justify="center">
            <Text size="1" weight="regular">
              {filename}
            </Text>
          </Flex>
        </Flex>
        <Flex pb="24px" direction={"column"}>
          <Flex
            justify="center"
            height="76px"
            py="12px"
            pr="24px"
            pl="8px"
            align="center"
            width="100%"
          >
            <Flex
              px="12px"
              py="10px"
              justify="center"
              align="center"
              gap="12px"
            >
              <Button
                size="2"
                color="accent"
                variant="solid"
                className={classes.button}
                onClick={downloadPdf}
              >
                <Text size="1" weight="bold">
                  Download
                </Text>
                <DownloadIcon />
              </Button>
              <Text
                size="1"
                weight="regular"
                className={classes.clickableText}
                onClick={cancelGenerate}
              >
                Back
              </Text>
            </Flex>
          </Flex>
          <Flex justify="center" direction="column" width="100%" align="center">
            <Text size="1" weight="regular">
              Experiencing issues with the downloaded file?
            </Text>
            <Text
              size="1"
              weight="regular"
              className={classes.clickableText}
              onClick={regenerate}
            >
              Re-generate Document
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
}
